import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

# TODO: This class should use 3 instances of PieSentimentView. Methods addSentimentPie and updatePercentage should be erased

class Monitoring.Reports.Executive.CompetitorsSentimentView extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/competitors_sentiment"]
  tagName: 'section'
  id: 'competitors-sentiment'

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    competitors = @options.settings.competitorsLabels

    @bindChartsReady(competitors.length * 4)

    @$el.html(@template(competitors: competitors))

    
    _.each(competitors, (competitor) =>
        competitor_id = competitor.description.toLowerCase().replace(/\s/g, '-')
        @addSentimentPie("#facebok-twitter-pie-#{competitor_id}", competitor.codes)
        @addSentimentPie("#twitter-pie-#{competitor_id}", competitor.codes, ['twitter'])
        @addSentimentPie("#facebook-pie-#{competitor_id}", competitor.codes, ['facebook'])
        @addHistogram(competitor.codes, competitor_id)
    )
    return this

  addSentimentPie: (divId, codes, type=false)->
    query = @competitorSentimentQuery(codes)
    query = _.extend({}, query, must_be_public_comments: true)
    query.type = type if type
    @_addPie(query, divId, { size: '200px', callback: @updatePercentage, drillDownFunction: (clickEvent) ->
      ret = {
        sentiment: [clickEvent.point.code]
      }
      ret.type = type if type
      ret
    } )

  updatePercentage: (response, divId) =>
    values = {}
    for point in response.series[0].data
      values[point.code] = point.y
    total = values.negative + values.neutral + values.positive

    positive_percentage = @_percentage(values.positive, total)
    $(divId).siblings('.pos').find('.percentage-positive').text(positive_percentage)

    neutral_percentage = @_percentage(values.neutral, total)
    $(divId).siblings('.neutral').find('.percentage-neutral').text(neutral_percentage)

    negative_percentage = @_percentage(values.negative, total)
    $(divId).siblings('.neg').find('.percentage-negative').text(negative_percentage)

  addHistogram: (codes, description) ->
    query = @competitorSentimentQuery(codes)
    query = _.extend({}, query, must_be_public_comments: true)

    @_addHistogram(query, "#sentiment-histogram-#{description}", { drillDownFunction: (clickEvent) =>
      from = new Date(clickEvent.point.x)
      to = new Date(clickEvent.point.x + clickEvent.point.series.pointInterval)
      {
        date_from: @_formatDate(from)
        date_from_ISO: from.toISOString()
        date_to: @_formatDate(to)
        date_to_ISO: to.toISOString()
        sentiment: [clickEvent.point.series.name.toLowerCase()]
        labels: [codes]
      }
    } )

  # TODO Duplicated
  _formatDate: (date) ->
    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return "#{date.getDate()} #{monthNames[date.getMonth()]} #{date.getFullYear()} #{date.toTimeString().substring(0,5)}"
